export default {"src":"/_next/static/media/products-webinar.53a68ba0.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};